import moment from 'moment'
export const ORBIT_STAGES = {
  SYNC: 'sync',
  ANALYSE: 'analyse',
  VERIFYING: 'verifying',
  DEEP_VERIFY: 'deep_verify',
  RESULT_GENERATION: 'result_generation',
  COMPLETED: 'completed',
}
export const ORBIT_STAGE_LABELS = {
  sync: 'syncing',
  analyse: 'analysing',
  verifying: 'Verification',
  deep_verify: 'Deep Verification',
  result_generation: 'Finalizing results',
  completed: 'Completed',
}
export const ORBIT_MODE_LABELS = {
  deep_verify: 'Deep Verify',
  highest_accuracy: 'Highest Accuracy',
  fastest_turnaround: 'Fastest Turnaround'
}
export const ORBIT_SEGMENT_ORDER = ['valid', 'invalid', 'catch_all', 'unknown']
export const ORBIT_SEGMENT_LABELS = {
  valid: 'Valid',
  invalid: 'Invalid',
  catch_all: 'Catch-all',
  unknown: 'Unknown',
}
export function getOrbitModel(progress) {
  if (!progress || !progress.stage || !progress.breakdown)
    return null
  const stage = progress.stage
  if (stage !== ORBIT_STAGES.VERIFYING && stage !== ORBIT_STAGES.DEEP_VERIFY && stage !== ORBIT_STAGES.RESULT_GENERATION) {
    return null
  }
  const breakdown = progress.breakdown
  const counts = progress.counts || {}
  const dv = progress.deep_verify || null
  const isDeepVerify = stage === ORBIT_STAGES.DEEP_VERIFY
  const allKeys = [...ORBIT_SEGMENT_ORDER, 'unscanned', 'deep_verify_pending']
  const sum = allKeys.reduce((acc, k) => acc + (Number(breakdown[k]) || 0), 0)
  const segments = ORBIT_SEGMENT_ORDER.map((key) => {
    const count = Number(breakdown[key]) || 0
    const label = ORBIT_SEGMENT_LABELS[key]
    const tooltip = key === 'deep_verify_pending'
      ? (getBlueSliceTooltip(dv) || `${label} · ${count.toLocaleString()}`)
      : `${label} · ${count.toLocaleString()}`
    return { key, count, label, tooltip }
  })
  const legend = segments
  const classifiedCount = ORBIT_SEGMENT_ORDER.reduce(
    (acc, key) => acc + (Number(breakdown[key]) || 0), 0
  )
  let pct = counts.total ? (classifiedCount / counts.total) * 100 : 0
  let innerFraction
  if (isDeepVerify) {
    innerFraction = dv && Number.isFinite(Number(dv.percentile)) ? Number(dv.percentile) / 100 : 0
  } else {
    innerFraction = counts.total ? (Number(counts.scanned) || 0) / counts.total : 0
  }
  innerFraction = Math.max(0, Math.min(1, innerFraction))
  return {
    stage,
    stageLabel: ORBIT_STAGE_LABELS[stage] || stage,
    isDeepVerify,
    sum,
    total: counts.total,
    segments,
    legend,
    innerFraction,
    centerPrimary: `${Math.round(pct)}%`,
    centerSecondary: isDeepVerify
      ? (formatDvEtaLabel(dv) || 'deep verifying…')
      : 'analyzing…',
  }
}
export function formatDvEtaLabel(dv) {
  if (!dv) return null
  if (dv.eta) return `est. ${moment(dv.eta).format('MMM D, h:mm A')}`
  if (dv.wait_until) return `by ${moment(dv.wait_until).format('MMM D, h:mm A')}`
  return null
}
export function getTimeRemainingLabel(targetDate) {
  if (!targetDate) return null
  const target = moment(targetDate)
  if (!target.isValid()) return null
  const diffMs = target.diff(moment())
  if (diffMs <= 0) return null
  const dur = moment.duration(diffMs)
  const days = Math.floor(dur.asDays())
  const hours = dur.hours()
  const minutes = dur.minutes()
  const parts = []
  if (days > 0) parts.push(`${days} day${days !== 1 ? 's' : ''}`)
  if (hours > 0) parts.push(`${hours} hour${hours !== 1 ? 's' : ''}`)
  if (days === 0 && hours === 0) parts.push(`${minutes} minute${minutes !== 1 ? 's' : ''}`)
  return `About ${parts.join(' ')}`
}
export function getBlueSliceTooltip(dv) {
  if (!dv) return null
  const pending = Number.isFinite(Number(dv.pending))
    ? Number(dv.pending)
    : (Number(dv.total) || 0) - (Number(dv.settled) || 0)
  const split = dv.settled_split || {}
  const valid = Number(split.valid) || 0
  const invalid = Number(split.invalid) || 0
  return `Deep verify in progress · ${pending.toLocaleString()} left · `
    + `settled so far: ${valid.toLocaleString()} valid / ${invalid.toLocaleString()} invalid`
}
